<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";
import { addSizeToDataLayer } from "@/functions/analytics";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";
import {Props} from "@/components/ShapeType.vue";

const store = useStore();
const { isCutout, action, prefix } = defineProps<Props>();

const dimensions = computed(() => store.getters.getMeasurements( 'rectangle', isCutout ) );
const dimensionLabel = computed(() => store.getters.dimensionLabel);
const dimensionMaxLabel = computed(() => store.getters.getMaxLabelForDimension);
const isDimensionValid = computed(() => store.getters.isShapeValid( isCutout ) );

const width = computed({
	get: () => dimensions.value.width,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "width",
			value: value,
		});
	}
});

const length = computed({
	get: () => dimensions.value.length,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "length",
			value: value,
		});
	},
});
</script>
<template>
	<shape-input-fields-wrapper>
		<dimension-input
			inputRef="rectangle-length"
			:id="`${prefix}measurements-rectangle-length`"
			:name="`${prefix}measurements[dimensions][length]`"
			unit="cm"
			:label="dimensionLabel('width', 'rectangle')"
			:instructions="isCutout ? '' : dimensionMaxLabel('width')"
			:invalid="!isDimensionValid(`${prefix}rectangle-length`)"
			:onBlur="() => addSizeToDataLayer('length', +length, 'rectangle')"
			v-model="length"
		/>

		<dimension-input
			inputRef="rectangle-width"
			:id="`${prefix}measurements-rectangle-width`"
			:name="`${prefix}measurements[dimensions][width]`"
			unit="cm"
			:label="dimensionLabel('height', 'rectangle')"
			:instructions="isCutout ? '' : dimensionMaxLabel('height')"
			:invalid="!isDimensionValid(`${prefix}rectangle-width`)"
			:onBlur="() => addSizeToDataLayer('width', +width, 'rectangle')"
			v-model="width"
		/>
	</shape-input-fields-wrapper>
</template>
